require('./listvideo.css');
let Core = require('../modules/core/');
let Poster = require('../modules/poster/');
let PlayButton = require('../modules/playButton/');
let Control = require('../modules/recodeControl/');
// var Title = require('../modules/title/');
let ErrorBox = require('../modules/error');
let statistics = require('../modules/statistics');

let Events = require('f.core.event');

let mp4Url = '//dyn.v.ifeng.com/cmpp/video_msg_ipad.js';
let ugcMp4Url = '//api.cmpp.v.ifeng.com/index.php/live/video';

let getVideoInfo = function(options) {
    let url = options.from && options.from == 'ugc' ? ugcMp4Url : mp4Url;
    let msg = options.from && options.from == 'ugc' ? options.uid + '@' + options.liveVideoId : options.liveVideoId;

    return $.ajax({
        url: url,
        dataType: 'jsonp',
        data: {
            msg: msg,
            rt: 'js',
            param: 'playermsg'
        }
    });
};

let Video = function(options) {
    this.options = options;
    this.init();
    this.currentTime = 0;
};

Video.prototype.init = function() {
    this.initParams();
    this.initLayout();
    this.initCompontent();
    this.initEvent();
};

Video.prototype.initParams = function() {};

Video.prototype.initLayout = function() {
    this.el = document.createElement('div');
    this.el.classList.add('c-video--plist');
};

Video.prototype.initCompontent = function() {
    let self = this;
    let videoOption = this.options;
    this.playermsg = getVideoInfo(videoOption);

    this.core = new Core({
        src: videoOption.video_url,
        poster: videoOption.video_image,
        inline: true,
        autoplay: this.options.autoplay
    });

    pageVideoList.push(this.core);

    this.poster = new Poster(videoOption.video_image);
    // this.title = new Title(this.options.title, this.options.channelName, this.options.channelIcon);

    this.playButton = new PlayButton();
    this.playButton.changeState('pause');
    this.control = new Control(this.options, true); // true表示为图文直播列表里用的control
    this.error = new ErrorBox(this.options.errorTitle);

    this.core.renderTo(this.el);

    this.poster.renderTo(this.el);

    this.playButton.renderTo(this.el);
    this.control.renderTo(this.el);
    // this.title.renderTo(this.el);
    this.error.renderTo(this.el);
};

Video.prototype.renderTo = function(parentNode) {
    parentNode.appendChild(this.el);
};

/**
 * 自定义事件列表
 * begin 每个视频开始播放时 一般用来发cv统计
 * ended 视频播放结束时
 * pause 视频暂停
 * play 视频播放
 * init 初始化视频 主要用于发vv统计
 */
Video.prototype.initEvent = function() {
    let core = this.core;
    let control = this.control;
    let playButton = this.playButton;
    let poster = this.poster;
    // var title = this.title;
    let error = this.error;
    let self = this;

    core.on('begin', function() {
        console.log('=======begin');
        self.playermsg.then(function(msg) {
            statistics(msg, 'cv');
        });
        self.control.show();
        self.trigger('begin');
    });

    core.on('loadedmetadata', function() {
        self.playermsg.then(function(msg) {
            statistics(msg, 'vv');
        });
        self.trigger('init');
    });

    // 视频播放
    core.on('play', function() {
        console.log('-------play====');
        // let current = Core.current();
        self.trigger('listVideoPlay');
        // if (current && core !== current) {
        //     current.pause();
        // }
        for (let i = 0; i < pageVideoList.length; i++) {
            const otherCore = pageVideoList[i];
            if (otherCore !== core) {
                otherCore.pause();
            }
        }
        playButton.changeState('play');
        control.changePlayState('play');

        poster.hide();

        error.hide();
    });

    // 视频暂停
    core.on('pause', function() {
        playButton.changeState('pause');
        control.changePlayState('pause');
        self.trigger('pause');
    });

    // 视频播放完成
    core.on('ended', function() {
        playButton.changeState('replay');
        self.trigger('ended');
    });
    // 视频重置

    // core.on('reset', function () {
    //     playButton.changeState('pause');
    //     control.changePlayState('pause');
    // });

    // 视频播放更新
    core.on('timeupdate', function() {
        let duration = core.getDuration();
        let currentTime = core.getCurrentTime();
        control.setTime(currentTime / duration, false);
        control.setTimeVal(Math.floor(duration - currentTime));
        self.trigger('timeupdate', core.getCurrentTime());
        self.currentTime = currentTime;
    });

    // title.on('exit', function () {
    //   self.trigger('exit');
    //   console.log('exit');
    // });

    // 点击播放器前面的控制蒙层
    playButton.on('click', function(e) {
        if (!window.adVideoIsEnd) {
            return;
        }

        if (core.getEnded() || core.getPaused()) {
            core.play();
        } else {
            control.toggle();
        }
    });

    // 控制条时间轴变化
    control.on('time', function(val) {
        let duration = core.getDuration();
        if (duration) {
            core.setCurrentTime(duration * val);
        }
    });

    // 控制条点击播放按钮
    control.on('play', function() {
        if (core.getPaused()) {
            core.play();
        } else {
            core.pause();
        }
    });

    control.on('zoom', function(state) {
        self.trigger('zoom', state);
    });

    // 控制条隐藏的同时，隐藏标题
    control.on('show', function() {
        // title.show();

        self.trigger('controlShow');
    });

    // 控制条显示的同时，显示标题
    control.on('hide', function() {
        // title.hide();

        self.trigger('controlHide');
    });
};

Video.prototype.play = function() {
    this.core.play();
};

Video.prototype.pause = function() {
    this.core.pause();
};

Video.prototype.stop = function() {
    this.core.pause();
    this.control.setTime(0);
};

Video.prototype.next = function(src) {
    this.core.src(src);
    this.control.reset();
    this.playButton.changeState('pause');
};

Video.prototype.getCurrentTime = function() {
    return this.currentTime;
};

Video.prototype.destory = function() {
    this.off();
    this.control.destory();
    this.poster.destory();
    this.playButton.destory();
    this.error.destory();
    core.destory();
};

Events.mixTo(Video);
module.exports = Video;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/lib/listVideo.js